/**
 * Renderer for link-cell columns: `building` and `account`.
 *
 * The server returns a URL path (e.g. "/buildings/123") in `building` and
 * the display label in `buildingName` / `accountName`. When the URL path
 * matches the current page's pathname, render a plain span instead of a link
 * (same guard as the legacy Kendo template: `if (building == window.location.pathname)`).
 *
 * Renders a dash when the column value is null.
 */
import React from 'react';
export function SeriesLinkRenderer({ item, dataKey }) {
    if (dataKey === 'building') {
        const { building, buildingName } = item;
        if (!building)
            return React.createElement("span", null, "-");
        if (building === window.location.pathname)
            return React.createElement("span", null, buildingName);
        return React.createElement("a", { href: building }, buildingName);
    }
    if (dataKey === 'account') {
        const { account, accountName } = item;
        if (!account)
            return React.createElement("span", null, "-");
        if (account === window.location.pathname)
            return React.createElement("span", null, accountName);
        return React.createElement("a", { href: account }, accountName);
    }
    return React.createElement("span", null, "-");
}
